import { render, staticRenderFns } from "./core_embed_youtube.vue?vue&type=template&id=64b6b9dc&scoped=true"
import script from "./core_embed_youtube.vue?vue&type=script&lang=js"
export * from "./core_embed_youtube.vue?vue&type=script&lang=js"
import style0 from "./core_embed_youtube.vue?vue&type=style&index=0&id=64b6b9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6b9dc",
  null
  
)

export default component.exports